import Entity from "lib/models/Entity";
import { computed } from "mobx";

interface CaseTypeSource {
  base: string;
  caseName: string;
}

export default class CaseType extends Entity<CaseTypeSource> {
  @computed
  get base(): string {
    return this.source.base;
  }

  @computed
  get caseName(): string {
    return this.source.caseName;
  }

  @computed
  get value(): string {
    return `${this.source.base}-${this.source.caseName}`;
  }
}

export type { CaseTypeSource };
